import React from 'react';

export default class ReportDisclaimer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'report-disclaimer-wrapper'}>
        <div className={'disclaimer-heading'}>{'Disclaimer'}</div>
        <div className={'disclaimer-sub-heading'}>
          {'You should take into consideration the following points before going over the report:'}
        </div>
        <div className={'disclaimer-point'}>
          {'1. The information found is reported as is on the date of generating this report.'}
        </div>
        <div className={'disclaimer-point'}>
          {'2. Details given here do not constitute as legal counsel or opinion.'}
        </div>
        <div className={'disclaimer-point'}>
          {
            '3. We have collected the information from publicly available records and data. We try to the maximum possible extent to reduce errors. However, SpringVerify cannot guarentee that the information given is 100% accurate.'
          }
        </div>
        <div className={'disclaimer-point'}>
          {
            '4. The information collected is limited to sources available to us and may not be completely up-to-date as they are not under the control of SpringVerify.'
          }
        </div>
        <div className={'disclaimer-point'}>
          {
            '5. Since all the sources of information are not updated or available in an online medium, absence of matches do not mean that there is no ongoing court case for the indvidual. Names are matched both fully and partially and hence might include cases pertaining to a person involved with similar name or details.'
          }
        </div>
        <div className={'disclaimer-point'}>
          {
            '6. Court checks are also limited by address information and might lead to mismatches or missing information when the address provided is not the same as the one that appears in court records.'
          }
        </div>
        <div className={'disclaimer-footer'}>
          {'For further information or clarifications, please reach out to us at: '}
          <b>{'info@springverify.com'}</b>
        </div>
      </div>
    );
  }
}

ReportDisclaimer.defaultProps = {};
